import React, { useState } from 'react';
import { useAuthContext } from '../../context/AuthContext';
import DataManagementTab from './DataManagementTab';
import SecurityTab from './SecurityTab';
import './UserSettings.css';

export default function UserSettings({ isOpen, onClose }) {
  const { isLoading, signOut } = useAuthContext();
  const [activeTab, setActiveTab] = useState('security');
  const [isLoadingSettings] = useState(false);

  const handleSignOut = async () => {
    await signOut();
    onClose();
  };

  const tabs = [
    // { id: 'profile', label: 'Profile', icon: 'fas fa-user', category: 'user' },
    { id: 'security', label: 'Security', icon: 'fa fa-lock', category: 'user' },
    { id: 'data', label: 'Data Management', icon: 'fas fa-database', category: 'user' },
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      // case 'profile':
      //   return <ProfileTab user={user} isLoading={isLoadingSettings} />;
      case 'security':
        return <SecurityTab isLoading={isLoadingSettings} />;
      case 'data':
        return <DataManagementTab isLoading={isLoadingSettings} />;
      default:
        return <SecurityTab isLoading={isLoadingSettings} />;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="user-settings-overlay" onClick={onClose}>
      <div className="user-settings-modal" onClick={(e) => e.stopPropagation()}>
        <div className="user-settings-header">
          <h2>User Settings</h2>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="user-settings-content">
          <div className="settings-sidebar">
            <nav className="settings-nav">
              {/* User Settings Section */}
              <div className="nav-section">
                <h3 className="nav-section-title">User Settings</h3>
                {tabs.filter(tab => tab.category === 'user').map((tab) => (
                  <button
                    key={tab.id}
                    className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
                    onClick={() => handleTabChange(tab.id)}
                    disabled={isLoading}
                  >
                    <i className={tab.icon}></i>
                    <span>{tab.label}</span>
                  </button>
                ))}
              </div>

              {/* Sign Out Button */}
              <div className="nav-section">
                <button
                  className="nav-tab sign-out-btn"
                  onClick={handleSignOut}
                >
                  <i className="fas fa-sign-out-alt"></i>
                  <span>Sign Out</span>
                </button>
              </div>
            </nav>
          </div>

          <div className="settings-main">
            <div className="tab-content">
              {renderActiveTab()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
